<!-- Desktop Version -->
<div class="d-none d-lg-block" style="width: 100vw">
  <div class="row">
    <div class="col-6 col-md-2 col-lg-2 col-sm-2">
      <a href="https://lendingman.com"> <img src="assets/logos/lendingman_desktop_app.svg" width="150" height="95" alt="LendingMan Logo" class="img-responsive" style="padding-top: 5px;"></a>
    </div>
    <div class="col-6 col-md-10 col-lg-10 col-sm-10">
      <div class="row">
        <div class="col-7 text-left my-4">
         <button *ngIf="isLoanOriginatorDashboardViewAllowed" ghost nbButton routerLink="/dashboard"><fa-icon class="m-1" size="1x" [icon]="leftArrow"></fa-icon>Dashboard</button>
         <button *ngIf="isSettingsViewAllowed" ghost nbButton (click)="navigateTo()"><nb-icon icon="settings"></nb-icon>Settings</button>
         <button disabled *ngIf="isContactsViewAllowed" ghost nbButton (click)="navigateToContacts()" ><nb-icon icon="settings"></nb-icon>Contacts</button>
         <button disabled *ngIf="isReportViewAllowed" ghost nbButton><nb-icon icon="settings"></nb-icon>Reports</button>
         <button disabled *ngIf="isTrainingViewAllowed" ghost nbButton><nb-icon icon="settings"></nb-icon>Training</button>
       </div>
      <div class="col-3 text-right my-4">


      </div>
        <div class="col-2 float-right my-4">

        -  <nb-action class="user-action" *nbIsGranted="['view', 'user']" >
            <nb-user [nbContextMenu]="userMenu"
                     [name]="user?.firstName"
            >
            </nb-user>
          </nb-action>
        </div>
      </div>





    </div>

  </div>
</div>
<!-- Mobile Version -->
<div class="row d-lg-none">
  <div class="navbar-brand minimum">
    <a href="https://lendingman.com"><img src="assets/logos/lendingman_mobile_app.svg" width="60" height="60" alt="LendingMan Mobile Logo"></a>
  </div>
</div>

